/**
 * THE VENDOR IMPORT'S SECOND CONFIRMATION (QA wave B1, 2026-09-22, B1-07).
 *
 * The importer's rule is that a vendor missing from the file is marked
 * inactive, and the preview says so loudly — a red count, a yellow block, the
 * first twenty names, and the number in the button. What it did not have was a
 * second press. A truncated upload — three rows where 162 were meant — is one
 * click from retiring 98% of the vendor master, and the only way back is to set
 * each vendor active one at a time.
 *
 * So: confirm when the file would deactivate a STRICT MAJORITY of the vendors
 * that are active today. That is the shape of a truncated or wrong file and
 * nothing else — a real list arrives with the master roughly intact, and a
 * routine import deactivating two vendors must not learn to ask twice, or the
 * second press becomes a reflex and stops being a guard.
 *
 * Its own module, not a constant inside the screen, because the threshold is a
 * rule about data and a test has to be able to call it.
 */

/**
 * @param deactivating how many active vendors the file would mark inactive.
 * @param activeBefore how many vendors are active now.
 */
export function importWouldGutTheList(deactivating: number, activeBefore: number): boolean {
  if (deactivating <= 0 || activeBefore <= 0) return false
  return deactivating * 2 > activeBefore
}

/** Every vendor active before the import: the file either leaves it alone,
    updates it, or does not mention it. An ADDED vendor is not one of them. */
export function activeVendorsBefore(counts: {
  unchanged_count: number
  updates: number
  absent_total: number
}): number {
  return counts.unchanged_count + counts.updates + counts.absent_total
}
